export var NotificationMeasuredRuleScope;
(function (NotificationMeasuredRuleScope) {
    NotificationMeasuredRuleScope["SOURCE_OR_GROUP"] = "advanced";
    NotificationMeasuredRuleScope["COMPANY"] = "basic";
})(NotificationMeasuredRuleScope || (NotificationMeasuredRuleScope = {}));
